import { render, staticRenderFns } from "./AngsuranAnggota.vue?vue&type=template&id=0e422acf"
import script from "./AngsuranAnggota.vue?vue&type=script&lang=js"
export * from "./AngsuranAnggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports